import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../../grid/Grid';
import FieldSet from '../../fieldset/FieldSet';
import SearchBar from '../../searchbar/SearchBar';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../modules/Constants';
import SMSService from '../../../service/SMSService';
import DetailedMessageModal from './DetailedMessageModal';

class SMSSearchView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: [],
      rows: [],
      selectedMessage: null,
    };

    this.comboFields = [
      {
        value: 'customerId',
        display: 'Customer Id',
      },
      {
        value: 'serviceOfferingId',
        display: 'Service Offering Id',
      },
    ];
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.statefulInitialization(requestedState);
    }
  }

  onRowSelect(clickedMessage) {
    const { rows, } = this.state;
    const selectedMessage = rows.find((row) => {
      const { raw, } = row;
      return raw._id === clickedMessage._id;
    });
    this.setState({
      selectedMessage: selectedMessage.raw,
    });
  }

  onClick(event) {
    this.reset();
    const { combo, search, } = event;
    const { requestedState = {}, } = this.props;
    const { customerId = '', } = requestedState;
    const rows = [];
    const headers = [
      {
        value: '_id',
        display: 'Message Id',
      },
      {
        value: 'customerId',
        display: 'Customer Id',
      },
      {
        value: 'serviceOfferingId',
        display: 'Service Offering',
      },
      {
        value: 'message',
        display: 'Message',
      },
      {
        value: 'status',
        display: 'Status',
      },
    ];

    const criteria = {};
    criteria[combo.value] = search.value.length === 0 ? customerId : search.value;

    SMSService.getMessages(criteria)
      .then((response) => {
        const { messages, } = response.data;
        if (messages.length > 0) {
          messages.forEach((message) => {
            rows.push({
              value: [
                message._id,
                message.smsTemplate.customerId,
                message.smsTemplate.serviceOfferingId,
                message.smsTemplate.message,
                message.status.status,
              ],
              raw: message,
            });
          });
        }

        this.setState({
          headers,
          rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  showMessageInformation(message) {
    const { sendNavigationRequest, } = this.props;
    if (!message) {
      return null;
    }

    return (
      <div>
        <p>{`Selected ID: ${message._id}`}</p>
        <hr />
        <DetailedMessageModal sendNavigationRequest={sendNavigationRequest} selectedMessage={message} />
      </div>
    );
  }

  statefulInitialization() {
    const { click, } = this;
    if (click) {
      click();
    }
  }

  reset() {
    this.setState({
      headers: [],
      rows: [],
      selectedMessage: null,
    });
  }

  _setClickEvent(click) {
    this.click = click;
  }

  render() {
    const { requestedState = {}, } = this.props;
    const { customerId = '', } = requestedState;
    const { headers = [], rows = [], selectedMessage, } = this.state;
    const style = {
      maxHeight: '400px',
    };
    return (
      <div className="container">
        <SearchBar
          comboFields={this.comboFields}
          defaultText={customerId}
          onClick={data => this.onClick(data)}
          clickConsumer={click => this._setClickEvent(click)}
        />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Messages" style={style}>
            <Grid
              headers={headers}
              rows={rows}
              onRowSelect={data => this.onRowSelect(data)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.showMessageInformation(selectedMessage)}
        </div>
      </div>
    );
  }
}

SMSSearchView.defaultProps = {
  requestedState: undefined,
};

SMSSearchView.propTypes = {
  requestedState: PropTypes.instanceOf(Object),
  sendNavigationRequest: PropTypes.instanceOf(Function).isRequired,
};

export default SMSSearchView;
